// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/models/api/v1/pagination.proto" (package "c1.models.api.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.models.api.v1.PaginationToken
 */
export interface PaginationToken {
    /**
     * @generated from protobuf field: string pk = 1
     */
    pk: string;
    /**
     * @generated from protobuf field: string sk = 2
     */
    sk: string;
    /**
     * @generated from protobuf field: string gsi1pk = 3
     */
    gsi1Pk: string;
    /**
     * @generated from protobuf field: string gsi1sk = 4
     */
    gsi1Sk: string;
    /**
     * @generated from protobuf field: uint32 shard = 5
     */
    shard: number;
}
/**
 * @generated from protobuf message c1.models.api.v1.SearchPaginationToken
 */
export interface SearchPaginationToken {
    /**
     * @generated from protobuf field: int64 offset = 1
     */
    offset: number;
}
/**
 * https://cloud.google.com/apis/design/design_patterns#list_pagination
 *
 * @generated from protobuf message c1.models.api.v1.PaginationRequest
 */
export interface PaginationRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * intenral option to ignore page_size and page_token: fetch all objects, and returns
     * PaginationResponse with next_page_token empty.
     *
     * @generated from protobuf field: bool unroll_all = 3
     */
    unrollAll: boolean;
    /**
     * @generated from protobuf field: bool override_max_page_size = 4
     */
    overrideMaxPageSize: boolean;
}
/**
 * @generated from protobuf message c1.models.api.v1.PaginationResponse
 */
export interface PaginationResponse {
    /**
     * @generated from protobuf field: string next_page_token = 1
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.models.api.v1.ScanShardedOrderedPageToken
 */
export interface ScanShardedOrderedPageToken {
    /**
     * @generated from protobuf field: uint32 current_shard = 1
     */
    currentShard: number;
    /**
     * @generated from protobuf field: repeated c1.models.api.v1.ShardPagingKey paging_keys = 2
     */
    pagingKeys: ShardPagingKey[];
    /**
     * @generated from protobuf field: string high_water_mark_sort_key = 3
     */
    highWaterMarkSortKey: string;
    /**
     * @deprecated
     * @generated from protobuf field: string partition_key_without_shard = 4 [deprecated = true]
     */
    partitionKeyWithoutShard: string;
}
/**
 * @generated from protobuf message c1.models.api.v1.ShardPagingKey
 */
export interface ShardPagingKey {
    /**
     * @generated from protobuf field: uint32 shard_num = 1
     */
    shardNum: number;
    /**
     * @generated from protobuf field: string last_seen_sort_key = 2
     */
    lastSeenSortKey: string;
    /**
     * @generated from protobuf field: bool updated = 3
     */
    updated: boolean;
    /**
     * @generated from protobuf field: bool exhausted = 4
     */
    exhausted: boolean;
    /**
     * @generated from protobuf field: uint32 page_size = 5
     */
    pageSize: number;
    /**
     * @generated from protobuf field: uint32 search_limit = 6
     */
    searchLimit: number;
}
/**
 * @generated from protobuf enum c1.models.api.v1.SortDirection
 */
export enum SortDirection {
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_ASC = 1;
     */
    ASC = 1,
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_DESC = 2;
     */
    DESC = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class PaginationToken$Type extends MessageType<PaginationToken> {
    constructor() {
        super("c1.models.api.v1.PaginationToken", [
            { no: 1, name: "pk", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sk", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "gsi1pk", kind: "scalar", jsonName: "gsi1pk", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "gsi1sk", kind: "scalar", jsonName: "gsi1sk", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "shard", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ], { "pgdb.v1.msg": { disabled: true } });
    }
    create(value?: PartialMessage<PaginationToken>): PaginationToken {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pk = "";
        message.sk = "";
        message.gsi1Pk = "";
        message.gsi1Sk = "";
        message.shard = 0;
        if (value !== undefined)
            reflectionMergePartial<PaginationToken>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PaginationToken): PaginationToken {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string pk */ 1:
                    message.pk = reader.string();
                    break;
                case /* string sk */ 2:
                    message.sk = reader.string();
                    break;
                case /* string gsi1pk */ 3:
                    message.gsi1Pk = reader.string();
                    break;
                case /* string gsi1sk */ 4:
                    message.gsi1Sk = reader.string();
                    break;
                case /* uint32 shard */ 5:
                    message.shard = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PaginationToken, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string pk = 1; */
        if (message.pk !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.pk);
        /* string sk = 2; */
        if (message.sk !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sk);
        /* string gsi1pk = 3; */
        if (message.gsi1Pk !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.gsi1Pk);
        /* string gsi1sk = 4; */
        if (message.gsi1Sk !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.gsi1Sk);
        /* uint32 shard = 5; */
        if (message.shard !== 0)
            writer.tag(5, WireType.Varint).uint32(message.shard);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.models.api.v1.PaginationToken
 */
export const PaginationToken = new PaginationToken$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchPaginationToken$Type extends MessageType<SearchPaginationToken> {
    constructor() {
        super("c1.models.api.v1.SearchPaginationToken", [
            { no: 1, name: "offset", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ], { "pgdb.v1.msg": { disabled: true } });
    }
    create(value?: PartialMessage<SearchPaginationToken>): SearchPaginationToken {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.offset = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchPaginationToken>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchPaginationToken): SearchPaginationToken {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 offset */ 1:
                    message.offset = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchPaginationToken, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 offset = 1; */
        if (message.offset !== 0)
            writer.tag(1, WireType.Varint).int64(message.offset);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.models.api.v1.SearchPaginationToken
 */
export const SearchPaginationToken = new SearchPaginationToken$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PaginationRequest$Type extends MessageType<PaginationRequest> {
    constructor() {
        super("c1.models.api.v1.PaginationRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "unroll_all", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "override_max_page_size", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ], { "pgdb.v1.msg": { disabled: true } });
    }
    create(value?: PartialMessage<PaginationRequest>): PaginationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.unrollAll = false;
        message.overrideMaxPageSize = false;
        if (value !== undefined)
            reflectionMergePartial<PaginationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PaginationRequest): PaginationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* bool unroll_all */ 3:
                    message.unrollAll = reader.bool();
                    break;
                case /* bool override_max_page_size */ 4:
                    message.overrideMaxPageSize = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PaginationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* bool unroll_all = 3; */
        if (message.unrollAll !== false)
            writer.tag(3, WireType.Varint).bool(message.unrollAll);
        /* bool override_max_page_size = 4; */
        if (message.overrideMaxPageSize !== false)
            writer.tag(4, WireType.Varint).bool(message.overrideMaxPageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.models.api.v1.PaginationRequest
 */
export const PaginationRequest = new PaginationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PaginationResponse$Type extends MessageType<PaginationResponse> {
    constructor() {
        super("c1.models.api.v1.PaginationResponse", [
            { no: 1, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ], { "pgdb.v1.msg": { disabled: true } });
    }
    create(value?: PartialMessage<PaginationResponse>): PaginationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<PaginationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PaginationResponse): PaginationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string next_page_token */ 1:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PaginationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string next_page_token = 1; */
        if (message.nextPageToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.models.api.v1.PaginationResponse
 */
export const PaginationResponse = new PaginationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScanShardedOrderedPageToken$Type extends MessageType<ScanShardedOrderedPageToken> {
    constructor() {
        super("c1.models.api.v1.ScanShardedOrderedPageToken", [
            { no: 1, name: "current_shard", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "paging_keys", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ShardPagingKey },
            { no: 3, name: "high_water_mark_sort_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "partition_key_without_shard", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ], { "pgdb.v1.msg": { disabled: true } });
    }
    create(value?: PartialMessage<ScanShardedOrderedPageToken>): ScanShardedOrderedPageToken {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.currentShard = 0;
        message.pagingKeys = [];
        message.highWaterMarkSortKey = "";
        message.partitionKeyWithoutShard = "";
        if (value !== undefined)
            reflectionMergePartial<ScanShardedOrderedPageToken>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ScanShardedOrderedPageToken): ScanShardedOrderedPageToken {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 current_shard */ 1:
                    message.currentShard = reader.uint32();
                    break;
                case /* repeated c1.models.api.v1.ShardPagingKey paging_keys */ 2:
                    message.pagingKeys.push(ShardPagingKey.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string high_water_mark_sort_key */ 3:
                    message.highWaterMarkSortKey = reader.string();
                    break;
                case /* string partition_key_without_shard = 4 [deprecated = true] */ 4:
                    message.partitionKeyWithoutShard = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ScanShardedOrderedPageToken, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 current_shard = 1; */
        if (message.currentShard !== 0)
            writer.tag(1, WireType.Varint).uint32(message.currentShard);
        /* repeated c1.models.api.v1.ShardPagingKey paging_keys = 2; */
        for (let i = 0; i < message.pagingKeys.length; i++)
            ShardPagingKey.internalBinaryWrite(message.pagingKeys[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string high_water_mark_sort_key = 3; */
        if (message.highWaterMarkSortKey !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.highWaterMarkSortKey);
        /* string partition_key_without_shard = 4 [deprecated = true]; */
        if (message.partitionKeyWithoutShard !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.partitionKeyWithoutShard);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.models.api.v1.ScanShardedOrderedPageToken
 */
export const ScanShardedOrderedPageToken = new ScanShardedOrderedPageToken$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ShardPagingKey$Type extends MessageType<ShardPagingKey> {
    constructor() {
        super("c1.models.api.v1.ShardPagingKey", [
            { no: 1, name: "shard_num", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "last_seen_sort_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "updated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "exhausted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "page_size", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "search_limit", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ], { "pgdb.v1.msg": { disabled: true } });
    }
    create(value?: PartialMessage<ShardPagingKey>): ShardPagingKey {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shardNum = 0;
        message.lastSeenSortKey = "";
        message.updated = false;
        message.exhausted = false;
        message.pageSize = 0;
        message.searchLimit = 0;
        if (value !== undefined)
            reflectionMergePartial<ShardPagingKey>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ShardPagingKey): ShardPagingKey {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 shard_num */ 1:
                    message.shardNum = reader.uint32();
                    break;
                case /* string last_seen_sort_key */ 2:
                    message.lastSeenSortKey = reader.string();
                    break;
                case /* bool updated */ 3:
                    message.updated = reader.bool();
                    break;
                case /* bool exhausted */ 4:
                    message.exhausted = reader.bool();
                    break;
                case /* uint32 page_size */ 5:
                    message.pageSize = reader.uint32();
                    break;
                case /* uint32 search_limit */ 6:
                    message.searchLimit = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ShardPagingKey, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 shard_num = 1; */
        if (message.shardNum !== 0)
            writer.tag(1, WireType.Varint).uint32(message.shardNum);
        /* string last_seen_sort_key = 2; */
        if (message.lastSeenSortKey !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.lastSeenSortKey);
        /* bool updated = 3; */
        if (message.updated !== false)
            writer.tag(3, WireType.Varint).bool(message.updated);
        /* bool exhausted = 4; */
        if (message.exhausted !== false)
            writer.tag(4, WireType.Varint).bool(message.exhausted);
        /* uint32 page_size = 5; */
        if (message.pageSize !== 0)
            writer.tag(5, WireType.Varint).uint32(message.pageSize);
        /* uint32 search_limit = 6; */
        if (message.searchLimit !== 0)
            writer.tag(6, WireType.Varint).uint32(message.searchLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.models.api.v1.ShardPagingKey
 */
export const ShardPagingKey = new ShardPagingKey$Type();
